"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 主入口
 */
require("core-js/features/object/assign");
require("core-js/features/promise");
require("core-js/features/math/trunc");
var addstyle_1 = require("./modules/addstyle");
var line_1 = require("./modules/line");
var zjl_1 = require("./modules/zjl");
// import { PieChart } from './modules/piechart';
//导入css
var csstxt = require("./css/index.css");
(0, addstyle_1.addStyle)(csstxt);
module.exports = {
    Line: line_1.Line,
    ZJLline: zjl_1.ZJLline,
    // PieChart
};
